// extracted by mini-css-extract-plugin
module.exports = {"button":"button-2bpkC","button_small":"button_small-3Meeq"};